import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategoriesSection from './components/CategoriesSection';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '直播互动体验平台',
  url: 'https://streamhubx.github.io/',
  description: '探索全新直播互动体验，与真实主播实时连线，畅享高清视频直播娱乐内容。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://streamhubx.github.io/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '直播互动体验平台',
  url: 'https://streamhubx.github.io/',
  description: '专业的直播互动娱乐平台，提供高清视频直播、实时连线互动等一站式服务。',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+86-400-888-8888',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="直播互动体验平台 - 实时连线娱乐，高清视频直播互动新体验"
        description="探索全新直播互动体验，与真实主播实时连线，畅享高清视频直播娱乐内容。平台安全可靠，注册即享专属福利，随时随地开启沉浸式直播互动新体验。涵盖才艺表演、游戏直播、聊天互动等八大直播分类。"
        keywords="直播互动,实时连线,视频直播,主播互动,在线娱乐,直播平台,高清直播"
        canonicalUrl="https://streamhubx.github.io/"
        ogTitle="直播互动体验平台 - 实时连线娱乐，高清视频直播互动新体验"
        ogDescription="探索全新直播互动体验，与真实主播实时连线，畅享高清视频直播娱乐内容。"
        ogUrl="https://streamhubx.github.io/"
        schemaData={[websiteSchema, organizationSchema]}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturesSection />
          <CategoriesSection />
          <FeaturedArticles />
          <FAQSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}